import { useCallback, useState } from 'react';

const STORAGE_KEY = 'meshpit_recent_commands';
const MAX_RECENTS = 10;

function readRecents(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeRecents(ids: string[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  } catch {
    // Silently fail if localStorage is unavailable
  }
}

export function useRecentCommands() {
  const [recents, setRecents] = useState<string[]>(readRecents);

  const recordUsed = useCallback((id: string) => {
    setRecents((prev) => {
      // Put id at the front, deduplicate, cap at MAX_RECENTS
      const next = [id, ...prev.filter((x) => x !== id)].slice(0, MAX_RECENTS);
      writeRecents(next);
      return next;
    });
  }, []);

  const clearRecents = useCallback(() => {
    writeRecents([]);
    setRecents([]);
  }, []);

  return { recents, recordUsed, clearRecents };
}
